// extracted by mini-css-extract-plugin
export var skipAnimation = "_13-0";